const helpers = require('./helpers');

module.exports = function(options = {}){

  const total = helpers.calculateAmountTotal({ order: this });
  const paid = this.getAmountPaid(options); // includes credits by default

  return total - paid;
};